export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-3xl bg-foreground-950 overflow-visible flex flex-col lg:flex-row">
          <div className="lg:w-2/5 -mt-10 lg:-mt-12 lg:-ml-10 px-6 lg:px-0">
            <div className="h-72 lg:h-full rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20stylish%20young%20adult%20smiling%20naturally%20in%20a%20bright%20modern%20loft%20space%20with%20warm%20cream%20walls%20soft%20natural%20window%20lighting%20editorial%20portrait%20photography%20clean%20european%20aesthetic%20authentic%20expression&width=500&height=600&seq=testimonial-v2&orientation=portrait"
                alt="Satisfied pandabuy sheet user"
                className="w-full h-full object-cover"
                title="Pandabuy Sheet happy user"
              />
            </div>
          </div>

          <div className="lg:w-3/5 flex flex-col justify-center p-8 md:p-12">
            <span className="text-5xl md:text-7xl font-heading font-black text-accent-400 leading-none opacity-70">
              &ldquo;
            </span>
            <p className="text-base md:text-lg text-background-50 leading-relaxed -mt-4">
              I used to spend hours scrolling through product pages trying to find decent quality items. Since discovering the pandabuy sheet collections, I can instantly compare the best-rated products across every category. It literally cut my shopping research time in half. The curated lists are genuinely useful.
            </p>
            <div className="mt-6">
              <p className="text-sm font-semibold text-background-50">
                Marcus K.
              </p>
              <p className="text-xs text-foreground-400">
                Verified Pandabuy Sheet User
              </p>
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center mt-6 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap w-fit cursor-pointer"
            >
              Try Pandabuy Sheet <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <span className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            <i className="ri-star-fill text-accent-500 text-sm"></i>
          </span>
          <span className="text-xs text-foreground-500">Trusted by 50,000+ shoppers worldwide</span>
        </div>
      </div>
    </section>
  );
}